























import { Vue, Component } from "@/shared/vuepack";
@Component({
  components: {
  }
})
export default class UmbOnboardingInfo extends Vue {

}
